import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";
import { useSearchParams } from "react-router-dom";

import { getSearchQuery } from "components/SearchInput/helpers";

import { AiIntegrationView } from "../useSearchAiIntegrations/gql";
import { sortIntegrations } from "./sort";

export const useFilteredIntegrations = (
  integrations: AiIntegrationView[],
  sortDescriptor: SortDescriptor
) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  return useMemo(() => {
    let filteredIntegrations = [...integrations];
    filteredIntegrations = filteredIntegrations.filter((integration) =>
      integration.name.toLowerCase().includes(searchInput.toLowerCase())
    );

    if (sortDescriptor.column) {
      filteredIntegrations = sortIntegrations(filteredIntegrations, sortDescriptor);
    }

    return filteredIntegrations;
  }, [integrations, searchInput, sortDescriptor]);
};
